const { ALLOW_FUTURE_CLASS } = require('../helpers/_utils');

module.exports = function init_forms() {

  if (typeof acf !== 'undefined') {
    // Prevent accordion toggle when the form wrapper has .accordion-no-collapse.
    // Bound on the container itself so it fires during bubble before ACF's document-level delegate.
    acf.addAction('ready', function() {
      document.querySelectorAll('.accordion-no-collapse').forEach(function(container) {
        container.addEventListener('click', function(e) {
          if (e.target.closest('.acf-accordion-title')) {
            e.stopImmediatePropagation();
            e.preventDefault();
          }
        });
        container.addEventListener('keydown', function(e) {
          if (e.which !== 13) return;
          if (e.target.closest('.acf-accordion-title')) {
            e.stopImmediatePropagation();
            e.preventDefault();
          }
        });
      });

      // ACF's accordion field type remembers open/closed state via
      // acf.getPreference("this.accordions") — shared globally across the
      // page, indexed by an accordion's ordinal position, and able to
      // silently override a field's own "open" setting. Every accordion
      // inside .accordion-no-collapse must always render open, so this
      // forces each one directly by selector — never by patching
      // acf.getPreference itself, since that function has no way to know
      // which accordion is asking and would affect every accordion on the
      // page, not just these.
      //
      // Matches ACF's own accordion Model.open() (acf-input.min.js): adds
      // the "-open" class, flips the icon, and marks the title expanded —
      // without the slide animation, since this runs once at page-ready
      // rather than on a user click. Showing the content itself is CSS's
      // job (.accordion-no-collapse .acf-accordion-content is display:block
      // !important in _acf_forms.scss), not this handler's.
      document.querySelectorAll('.accordion-no-collapse .acf-accordion').forEach(function(accordion) {
        if (accordion.classList.contains('-open')) return;
        accordion.classList.add('-open');
        const title = accordion.querySelector('.acf-accordion-title');
        if (title) title.setAttribute('aria-expanded', 'true');
        const icon = accordion.querySelector('.acf-accordion-icon');
        if (icon) {
          icon.classList.remove('dashicons-arrow-right');
          icon.classList.add('dashicons-arrow-down');
        }
      });
    });

    // ACF's own "equalize row heights" feature (fieldsHelper.renderGroup(),
    // in acf-input.min.js) measures every visible field in a flex row on its
    // 'refresh' action and applies a matching min-height to all of them, so
    // side-by-side fields with different content still line up. On a page
    // where the whole field group is visible immediately (Site Information,
    // Non-Site Observations — unlike Activity 3's Collection Location,
    // which starts hidden behind a toggle and so is always measured after
    // the page has already settled), this first pass can run before fonts/
    // Select2/etc. have finished settling, producing an inflated min-height
    // that then just sits there indefinitely. Forcing one more refresh once
    // the window has fully loaded re-measures with accurate values from the
    // start. Scoped to .accordion-no-collapse pages (Site Information,
    // Non-Site Observations, Activity 3), same as the other two fixes
    // above — no reason to pay for a full flex-row re-measurement pass on
    // pages with no such field group.
    if (document.querySelector('.accordion-no-collapse')) {
      window.addEventListener('load', function () {
        acf.doAction('refresh');
      });
    }

    // Allow target attribute in ACF error/notice messages (DOMPurify strips it by default).
    acf.addFilter('esc_html_dompurify_config', function (config) {
      config.ADD_ATTR = (config.ADD_ATTR || []).concat(['target']);
      return config;
    });

    // Cap every date picker at today (browser local date) unless its field
    // opts out with .allow-future. Runs before the picker is created.
    // Server-side counterpart: mlmp_acf_validate_no_future_date().
    acf.addFilter('date_picker_args', function(args, field) {
      if (!field.$el.hasClass(ALLOW_FUTURE_CLASS)) args.maxDate = 0;
      return args;
    });

    // for any time picker elements, make sure any related error messages
    // are hidden before calculating the position of the time picker
    acf.addFilter('time_picker_args', function(args, field) {
      args.beforeShow = function() {
        const notice = field.$el[0].querySelector('.acf-notice');
        if (notice) notice.style.display = 'none';
      };
      return args;
    });
  }
  
}
